import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { http, describeApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = not authed, object = authed
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: describeApiError(e, "Sign in failed") };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await http.post("/auth/logout");
    } catch (e) {
      // Network error during logout is non-fatal — we still clear local state below.
      // eslint-disable-next-line no-console
      console.warn("Logout request failed (clearing local session anyway):", e?.message || e);
    }
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, login, logout, refresh: fetchMe }),
    [user, login, logout, fetchMe]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
